<template>
    <rkm-overlay>
        <rkm-layout-body title="Mapa de atendimento">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/mapa-atendimento/List'

export default {
    components: {List},
}
</script>